import { render, staticRenderFns } from "./RequisitionPONumberMenu.vue?vue&type=template&id=72757ca6&"
import script from "./RequisitionPONumberMenu.vue?vue&type=script&lang=ts&"
export * from "./RequisitionPONumberMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports